import { ZOHO_CRM_INTEGRATION_DEMO_ARTIFACT_ID } from './zohoCrmIntegrationDemo.js'
import { NEXUS_CRM_INTEGRATION_ARTIFACT_FILE_NAME } from './nexusIntegrationsDemo.js'
import { buildZohoCrmIntegrationArtifactPayload } from './zohoCrmIntegrationDemoContent.js'

/**
 * @param {import('@/features/documentPreview/documentPreviewTypes.js').DocumentPreviewSelection} selection
 */
export function isZohoCrmIntegrationArtifact(selection) {
  const name = String(selection?.fileName ?? '').toLowerCase()
  return (
    selection?.artifactId === ZOHO_CRM_INTEGRATION_DEMO_ARTIFACT_ID ||
    name.includes('salesforce crm') ||
    name === 'readme.md' ||
    name.includes('salesforce-integration')
  )
}

/**
 * @param {string | undefined} artifactId
 * @param {import('@/features/documentPreview/documentPreviewTypes.js').DocumentPreviewSelection} selection
 * @returns {import('@/features/documentPreview/documentPreviewTypes.js').GeneratedArtifactPreview}
 */
export function buildZohoCrmIntegrationArtifact(artifactId, selection) {
  const id = artifactId || ZOHO_CRM_INTEGRATION_DEMO_ARTIFACT_ID
  return {
    artifactId: id,
    kind: 'doc',
    fileName: selection?.fileName ?? NEXUS_CRM_INTEGRATION_ARTIFACT_FILE_NAME,
    description: selection?.description ?? 'Markdown',
    payload: buildZohoCrmIntegrationArtifactPayload(),
  }
}
